import {IButtonSizePrimary} from "@pg-design/button-module";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {usePropertyReservationState} from "../hooks/use_property_reservation_state";
import {useStartReservationFlow} from "../hooks/use_start_reservation_flow";
import {PropertyReservationCtaPlacement, PropertyReservationCtaView} from "./PropertyReservationCtaView";

interface IProps {
    property: IPropertyDetail;
    placement: PropertyReservationCtaPlacement;
    size: IButtonSizePrimary;
    fullWidth?: boolean;
    className?: string;
}

export const PropertyReservationCta = (props: IProps) => {
    const {property, placement, size, fullWidth, className} = props;

    const {ctaState, request} = usePropertyReservationState(property, placement);
    const startReservation = useStartReservationFlow(request, {offerName: property.offer.name});

    return (
        <PropertyReservationCtaView
            ctaState={ctaState}
            placement={placement}
            size={size}
            fullWidth={fullWidth}
            className={className}
            onStart={startReservation}
        />
    );
};
import {IButtonSizePrimary} from "@pg-design/button-module";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {usePropertyReservationState} from "../hooks/use_property_reservation_state";
import {useStartReservationFlow} from "../hooks/use_start_reservation_flow";
import {PropertyReservationCtaPlacement, PropertyReservationCtaView} from "./PropertyReservationCtaView";

interface IProps {
    property: IPropertyDetail;
    placement: PropertyReservationCtaPlacement;
    size: IButtonSizePrimary;
    fullWidth?: boolean;
    className?: string;
}

export const PropertyReservationCta = (props: IProps) => {
    const {property, placement, size, fullWidth, className} = props;

    const {ctaState, request} = usePropertyReservationState(property, placement);
    const startReservation = useStartReservationFlow(request, {offerName: property.offer.name});

    return (
        <PropertyReservationCtaView
            ctaState={ctaState}
            placement={placement}
            size={size}
            fullWidth={fullWidth}
            className={className}
            onStart={startReservation}
        />
    );
};
